













import { computed, defineComponent } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import ConditionForm from '@/components/organisms/questionnaire/ConditionForm.vue'
import ConditionsTable from '@/components/organisms/questionnaire/ConditionsTable.vue'
import {
  ConditionEntity,
  CreateConditionDto,
  QuestionEntity,
} from '../../../api/@types'
import { useActions, useGetters } from 'vuex-composition-helpers'
import { UserGetters } from '@/store/user/getters'
import { QuestionnaireGetters } from '@/store/questionnaire/getters'

export default defineComponent({
  components: { Layout, ConditionForm, ConditionsTable },
  setup(props, context) {
    const pageId = parseInt(context.root.$route.params.pageId)
    const questionId = parseInt(context.root.$route.params.questionId)

    const { user } = useGetters<UserGetters>('user', ['user'])
    const { pages } = useGetters<QuestionnaireGetters>('questionnaire', [
      'pages',
    ])
    const { createCondition, deleteCondition } = useActions('questionnaire', [
      'createCondition',
      'deleteCondition',
    ])

    const question = computed<QuestionEntity>(() =>
      context.root.$store.getters['questionnaire/question'](pageId, questionId),
    )
    const conditions = computed(() =>
      (context.root.$store.getters['questionnaire/conditions'](
        pageId,
        questionId,
      ) as ConditionEntity[]).map(condition => {
        {
          return {
            ...condition,
            choices: question.value
              ? question.value.choices
                  .filter(choice => condition.choices.includes(choice.id))
                  .map(choice => choice.name)
              : [],
          }
        }
      }),
    )

    const save = async (payload: {
      body: Partial<CreateConditionDto>
      done: () => void
    }) => {
      await createCondition({
        questionId,
        body: {
          ...payload.body,
          questionId,
        },
      })
      payload.done()
    }

    return {
      user,
      pages,
      pageId,
      questionId,
      conditions,
      save,
      deleteCondition,
    }
  },
})
